<template>
  <div class="product-user-review">
    <product-review-head
      class="product-user-review__head"
      :name="name"
      :date="date"
      :city="city"
      :rating="rating"
      :use-time="useTime"
      :recommended="recommended"
    />

    <message-cloud
      class="product-user-review__message"
      :size="size"
      :pros="pros"
      :cons="cons"
      :text="text"
    >
      <product-review-answer
        v-for="(comment, index) in comments"
        :key="index"
        :text="comment.text"
        :date="createdDate(comment.created_at)"
      />
    </message-cloud>

    <review-likes
      class="product-user-review__likes"
      :likes="localLikes"
      :dislikes="localDislikes"
      @like="onLike"
      @dislike="onDislike"
    />
  </div>
</template>

<script>
import ProductReviewHead from './product-review-head.vue';
import MessageCloud from './message-cloud.vue';
import ReviewLikes from './review-likes.vue';
import ProductReviewAnswer from './product-review-answer.vue';
import { ddmmyyyy } from '@/utils/date-to-string';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'product-user-review',

  components: {
    MessageCloud,
    ReviewLikes,
    ProductReviewHead,
    ProductReviewAnswer,
  },

  props: {
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    city: {
      type: String,
      default: "",
    },
    rating: {
      type: Number,
      required: true,
    },
    useTime: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    pros: {
      type: String,
      default: "",
    },
    cons: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    likes: {
      type: Number,
      required: true,
    },
    dislikes: {
      type: Number,
      required: true,
    },
    recommended: {
      type: Boolean,
      default: false,
    },
    comments: {
      type: Array,
      default: () => ([]),
    }
  },

  data() {
    return {
      localLikes: this.likes,
      localDislikes: this.dislikes
    }
  },

  computed: {
    ...mapGetters({
      LOGGED_IN: 'user/loggedIn',
    }),
  },

  methods: {
    ...mapActions({
      VOTE_FOR_REVIEW: 'product/voteForReview',
    }),

    createdDate(date) {
      return ddmmyyyy(new Date(date));
    },
    showErrorAlreadyVoted() {
      this.$store.dispatch('notifications/create', {
        message: 'За этот отзыв вы проголосовали ранее',
      });
    },
    like() {
      this.VOTE_FOR_REVIEW({ reviewId: this.id })
        .then(() => {
          this.localLikes++;
        })
        .catch((error) => {
          if (error === 'already voted') {
            this.showErrorAlreadyVoted();
            return;
          }
        });
    },
    dislike() {
      this.VOTE_FOR_REVIEW({ reviewId: this.id, isLike: false })
        .then(() => {
          this.localDislikes++;
        })
        .catch((error) => {
          if (error === 'already voted') {
            this.showErrorAlreadyVoted();
            return;
          }
        });
    },
    onLike() {
      if (!this.LOGGED_IN) {
        this.$f.login().then(() => {
          this.like();
        }).catch(() => {});
      } else {
        this.like();
      }
    },
    onDislike() {
      if (!this.LOGGED_IN) {
        this.$f.login().then(() => {
          this.dislike();
        }).catch(() => {});
      } else {
        this.dislike();
      }
    }
  }
}
</script>

<style lang="scss">
  .product-user-review {
    &__head {
      margin-bottom: 16px;

      @include breakpoint("desktop") {
        margin-bottom: 18px;
      }
    }

    &__likes {
      margin-top: 16px;
    }

    &__message {
      @include breakpoint("desktop") {
        margin-left: 24px;
      }
    }
  }
</style>